import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box, Group, Anchor } from '@mantine/core';
import { IDLE_MS } from '../../utils/cvdl';
import { useIdleReset } from '../../hooks/useIdleReset';
import { useKiosk } from '../../context/KioskContext/KioskContext';
import { LogosEvento } from './LogosEvento';
import './kiosk.css';
import './cvdlClaro.css';

export function KioskLayout() {
  const { reset, isSpinning, rutas } = useKiosk();
  const { pathname } = useLocation();
  const enAtractor = pathname === rutas.base;

  useIdleReset(reset, IDLE_MS, !enAtractor && !isSpinning);

  // Fullscreen: requiere gesto del usuario, por eso va colgado del primer click
  useEffect(() => {
    const enter = () => document.documentElement.requestFullscreen?.().catch(() => { });
    document.addEventListener('click', enter, { once: true });
    return () => document.removeEventListener('click', enter);
  }, []);

  return (
    <Box
      className="kiosk cvdl-claro"
      style={{
        height: '100dvh', display: 'flex', flexDirection: 'column',
        overflow: 'hidden', userSelect: 'none', WebkitTapHighlightColor: 'transparent',
        background: 'linear-gradient(180deg, #FFFFFF 0%, #F4FAFD 100%)',
      }}
    >
      <Box maw="768px" m="0 auto" w="100%" px="xl" py="md" c="var(--color-text-primary)">
        <LogosEvento h={48} justify="center" />
      </Box>

      <Box style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        <Outlet />
      </Box>

      <Group justify="center" px="xl" py="sm">
        <Anchor href="https://forvet.org/cvdl/bases" size="sm" c="forvet.6">
          Bases y condiciones · forvet.org/cvdl/bases
        </Anchor>
      </Group>
    </Box>
  );
}
